export const PAYMENT_METHODS = {
  CREDIT_CARD: 'Credit Card',
  BANK_TRANSFER: 'Bank Transfer',
  PAYNOW: 'PayNow'
}
